import { Dispatch } from 'redux'
import { MenuAction, MenuItem, TaskCounters } from './interfaces'
import fetchApi from '../../../lib/utils/fetch-api'

let taskCountersRequest: Promise<TaskCounters> | null = null

export const fetchMenuRequest = () => ({
  type: 'FETCH_MENU_REQUEST' as const,
})

export const fetchMenuSuccess = (menu: MenuItem[]) => ({
  type: 'FETCH_MENU_SUCCESS' as const,
  payload: menu,
})

export const fetchMenuFailure = (error: string) => ({
  type: 'FETCH_MENU_FAILURE' as const,
  payload: error,
})

export const fetchMenu = () => {
  return (dispatch: Dispatch<MenuAction>) => {
    dispatch(fetchMenuRequest())
    fetchApi('/api/menu')
      .then(response => response)
      .then(data => dispatch(fetchMenuSuccess(data as MenuItem[])))
      .catch(error => dispatch(fetchMenuFailure(error.message)))
  }
}

export const setCounterData = data => {
  return {
    type: 'SET_COUNTER_DATA' as const,
    payload: data,
  }
}

export const setTaskCounters = (taskCounters: TaskCounters) => ({
  type: 'SET_TASK_COUNTERS' as const,
  payload: taskCounters,
})

const getTaskCounters = (response: Record<string, any>): TaskCounters => {
  const today = Number(response?.data?.today)
  const overdue = Number(response?.data?.overdue)

  return {
    today: Number.isFinite(today) ? today : 0,
    overdue: Number.isFinite(overdue) ? overdue : 0,
  }
}

export const fetchTaskCounters = () => {
  return async (dispatch: Dispatch<MenuAction>) => {
    if (!taskCountersRequest) {
      taskCountersRequest = fetchApi('/api/v2/tasks?summary=counters').then(getTaskCounters)
    }

    const currentRequest = taskCountersRequest

    try {
      const taskCounters = await currentRequest
      dispatch(setTaskCounters(taskCounters))
      return taskCounters
    } catch (error) {
      console.error('Ошибка загрузки счетчиков задач:', error)
      return null
    } finally {
      if (taskCountersRequest === currentRequest) {
        taskCountersRequest = null
      }
    }
  }
}
